const activities = [
  {
    name: 'uet-tag',
    value: 'uet-tag',
  },
  {
    name: 'setupTag',
    value: 'setupTag',
  },
  {
    name: 'setupTag.selectTag',
    value: 'setupTag.selectTag',
  },
  {
    name: 'setupTag.noTag',
    value: 'setupTag.noTag',
  },
  {
    name: 'setupTag.noTag.selectTagMethod',
    value: 'setupTag.noTag.selectTagMethod',
  },
  {
    name: 'setupTag.noTag.installTag',
    value: 'setupTag.noTag.installTag',
  },
  {
    name: 'setupTag.noTag.emailTag',
    value: 'setupTag.noTag.emailTag',
  },
  {
    name: 'setupTag.noTag.platformTag',
    value: 'setupTag.noTag.platformTag',
  },
  {
    name: 'setupTag.noTag.platformTagInstructions',
    value: 'setupTag.noTag.platformTagInstructions',
  },
  {
    name: 'setupTag.noTag.gtmTag',
    value: 'setupTag.noTag.gtmTag',
  },
  {
    name: 'endFlow',
    value: 'endFlow',
  },
];

export const instrumentationSchema = {
  scenario: [
    // All activities must be under this scenario so that we can later use SceId to string together a session.
    {
      name: 'uetSetupWizard',
      value: 'uetSetupWizard',
      activity: activities,
    },
  ],
};
